"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const utils_1 = require("@8base/utils");
const jwt_decode_1 = __importDefault(require("jwt-decode"));
/**
 * Creates instacne of the api token auth client
 */
class ApiTokenAuthClient {
    constructor(options, storageOptions = {}) {
        utils_1.throwIfMissingRequiredParameters(['apiToken'], utils_1.PACKAGES.API_TOKEN_AUTH_CLIENT, options);
        const { apiToken } = options;
        this.storageAPI = new utils_1.StorageAPI(storageOptions.storage || window.localStorage, storageOptions.storageKey || 'auth', storageOptions.initialState);
        this.apiToken = apiToken;
        this.storageAPI.setState({ token: apiToken });
    }
    getState() {
        return Object.assign({}, this.storageAPI.getState(), { token: this.apiToken });
    }
    getTokenInfo() {
        if (!this.apiToken) {
            return undefined;
        }
        return jwt_decode_1.default(this.apiToken) || undefined;
    }
    setState(state) {
        this.storageAPI.setState(Object.assign({}, state, { token: this.apiToken }));
    }
    purgeState() {
        this.storageAPI.purgeState();
        this.storageAPI.setState({ token: this.apiToken });
    }
    checkIsAuthorized() {
        return true;
    }
}
exports.ApiTokenAuthClient = ApiTokenAuthClient;
//# sourceMappingURL=ApiTokenAuthClient.js.map